<template>
  <v-container fluid grid-list-xl>
    <ul class="v-breadcrumbs ">
      <v-breadcrumbs-item key="inicio">Inicio</v-breadcrumbs-item>
      <li class="v-breadcrumbs__divider">/</li>
      <v-breadcrumbs-item key="level-1">
        {{ $route.matched[1].name }}
      </v-breadcrumbs-item>
      <li class="v-breadcrumbs__divider">/</li>
      <v-breadcrumbs-item disabled key="level-2">
        {{ $route.meta.title }}
      </v-breadcrumbs-item>
    </ul>
    <img
      :src="computeLogo"
      v-if="computeLogo"
      alt="Transit Web Template"
      height="50"
    />
  </v-container>
</template>
<script>
export default {
  computed: {
    computeLogo() {
      const name = this.$route.matched[1].name
      if (name != 'Dashboard' && name != 'Notificaciones' && name != 'Logs') {
        const path = '/static/section/' + name.toLowerCase() + '.png'
        return path
      }
      return null
    },
  },
}
</script>
